export default __webpack_public_path__ + "static/media/My project - 2023-05-23T173048.898 (1) (1).ee29ce7d.png";